import styled from "@emotion/styled";
import { Box } from "@kaltura/mediaspace-shared-styled";
import { systemWidth } from "@kaltura/mediaspace-shared-styled";

export const StyledBox = styled(Box)({
    width: "100%",
    height: "100%",
});

export const StyledContainer = styled(
    Box,
    {
        shouldForwardProp(propName: PropertyKey): boolean {
            return propName !== "isKaf";
        },
    }
)<{ isKaf?: boolean }>(({ theme, isKaf }) => ({
    "&": !isKaf && systemWidth({ theme }),
    display: "flex",
    height: "100%",
    alignItems: "center",
    ...(
        isKaf && {
            padding: theme.spacing(0, 6),
            [theme.breakpoints.down(theme.breakpoints.values.xl)]: {
                padding: theme.spacing(0, 5),
            },
            [theme.breakpoints.down(theme.breakpoints.values.lg)]: {
                padding: theme.spacing(0, 6),
            },
            [theme.breakpoints.down(theme.breakpoints.values.md)]: {
                padding: theme.spacing(0, 3),
            },
            [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
                padding: theme.spacing(0, 2),
            },
        }
    ),
}));

export const StyledInnerContainer = styled(Box)(({ theme }) => ({
    position: "relative", // Added just to make the inner-container be above StyledBlur (instead of messing with z-indexes)
    display: "flex",
    width: "100%",
    columnGap: theme.spacing(3),
    flexDirection: "row",
    maxHeight: "80%",
    [theme.breakpoints.down("md")]: {
        flexDirection: "column",
    },
}));

export const StyledDetailsContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    minWidth: "40%",
    alignItems: "unset",
    [theme.breakpoints.down("md")]: {
        alignItems: "center",
    },
}));

export const StyledSmallPosterContainer = styled(Box)(({theme}) => ({
    flexShrink: 0,
    display: "block",
    overflow: "hidden",
    borderRadius: theme.kaltura.shape.roundness2,
    position: "relative",
    "& video": {
        width: "100%",
        borderRadius: theme.kaltura.shape.roundness2,
    },
    width: 757,
    [theme.breakpoints.down("xl")]: {
        width: 686,
    },
    [theme.breakpoints.down("lg")]: {
        // This will make the width close to figma size (472px) in the lower section of the breakpoint,
        // but stretch nicely on the upper section
        width: "52%",
    },
}));

export const StyledSmallPoster = styled(
    Box,
    {
        shouldForwardProp: (prop) => !["url"].includes(prop.toString()),
    }
)(({ theme }) => ({
    position: "relative",
    aspectRatio: `${16 / 9}`,
    borderRadius: theme.kaltura.shape.roundness2,
    // Match the background color of V7 player while it's loading
    backgroundColor: "#000",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    width: "100%",
}));

export const StyledDataWrapper = styled("div")(({ theme }) => ({
    marginTop: theme.spacing(3),
}));
